<template>
    <img id="logo" :src="data.logo">

    <div class="schedule-container">
        <div class="schedule">
            <h2>Clase Gratis</h2>
            <form class="schedule-form">

                <div class="form-group">
                    <label for="name">Nombre:</label>
                    <input type="text" id="name" v-model="data.first_name" required>
                    <span class="info-icon" @mouseover="showPopup('Ingrese su nombre.')" @mouseleave="hidePopup">&#9432;</span>
                </div>
                
                <div class="form-group">
                    <label for="lastname">Apellido:</label>
                    <input type="text" id="lastname" v-model="data.last_name" required>
                    <span class="info-icon" @mouseover="showPopup('Ingrese su apellido.')" @mouseleave="hidePopup">&#9432;</span>
                </div>

                <div class="form-group">
                    <label for="date">Seleccionar Fecha de la Clase: {{ data.timezone }}</label>
                    <input type="date" id="date" v-model="data.date" required>
                    <span class="info-icon" @mouseover="showPopup('Seleccione la fecha en la que desea tomar la clase.')" @mouseleave="hidePopup">&#9432;</span>
                </div>
                
                <div class="form-group">
                    <label for="time">Seleccionar Hora de la Clase: {{ data.timezone }}</label>
                    <input type="time" id="time" v-model="data.time" required>
                    <span class="info-icon" @mouseover="showPopup('Seleccione la hora en la que desea tomar la clase.')" @mouseleave="hidePopup">&#9432;</span>
                </div>
                
                <div class="form-group">
                    <label for="email">Ingrese su Correo Electr&oacute;nico:</label>
                    <input type="email" id="email" v-model="data.email" placeholder="ejemplo@correo.com" required>
                    <span class="info-icon" @mouseover="showPopup('Ingrese su correo electr&oacute;nico para recibir confirmaci&oacute;n.')" @mouseleave="hidePopup">&#9432;</span>
                </div>
                
                <div class="form-group">
                    <label for="cellphone">Ingrese su N&uacute;mero de Tel&eacute;fono de Whatsapp:</label>
                    <div class=cellphone_info>
                        <input id="cellphone" class="cellphone" list="country_codes" v-model="data.country_code" placeholder="codigo de país" required>
                        <datalist id="country_codes" class="country_code">
                            <option value="+93">Afghanistan (+93)</option>
                            <option value="+355">Albania (+355)</option>
                            <option value="+213">Algeria (+213)</option>
                            <option value="+376">Andorra (+376)</option>
                            <option value="+244">Angola (+244)</option>
                            <option value="+1">Antigua and Barbuda (+1)</option>
                            <option value="+54">Argentina (+54)</option>
                            <option value="+374">Armenia (+374)</option>
                            <option value="+297">Aruba (+297)</option>
                            <option value="+61">Australia (+61)</option>
                            <option value="+43">Austria (+43)</option>
                            <option value="+994">Azerbaijan (+994)</option>
                            <option value="+1">Bahamas (+1)</option>
                            <option value="+973">Bahrain (+973)</option>
                            <option value="+880">Bangladesh (+880)</option>
                            <option value="+1">Barbados (+1)</option>
                            <option value="+375">Belarus (+375)</option>
                            <option value="+501">Belize (+501)</option>
                            <option value="+229">Benin (+229)</option>
                            <option value="+975">Bhutan (+975)</option>
                            <option value="+591">Bolivia (+591)</option>
                            <option value="+387">Bosnia and Herzegovina (+387)</option>
                            <option value="+267">Botswana (+267)</option>
                            <option value="+55">Brazil (+55)</option>
                            <option value="+673">Brunei (+673)</option>
                            <option value="+359">Bulgaria (+359)</option>
                            <option value="+226">Burkina Faso (+226)</option>
                            <option value="+257">Burundi (+257)</option>
                            <option value="+238">Cape Verde (+238)</option>
                            <option value="+855">Cambodia (+855)</option>
                            <option value="+237">Cameroon (+237)</option>
                            <option value="+1">Canada (+1)</option>
                            <option value="+235">Central African Republic (+235)</option>
                            <option value="+56">Chile (+56)</option>
                            <option value="+57">Colombia (+57)</option>
                            <option value="+269">Comoros (+269)</option>
                            <option value="+243">Congo (Brazzaville) (+243)</option>
                            <option value="+243">Congo (Kinshasa) (+243)</option>
                            <option value="+506">Costa Rica (+506)</option>
                            <option value="+385">Croatia (+385)</option>
                            <option value="+53">Cuba (+53)</option>
                            <option value="+357">Cyprus (+357)</option>
                            <option value="+420">Czech Republic (+420)</option>
                            <option value="+45">Denmark (+45)</option>
                            <option value="+253">Djibouti (+253)</option>
                            <option value="+1">Dominica (+1)</option>
                            <option value="+1">Dominican Republic (+1)</option>
                            <option value="+593">Ecuador (+593)</option>
                            <option value="+20">Egypt (+20)</option>
                            <option value="+503">El Salvador (+503)</option>
                            <option value="+240">Equatorial Guinea (+240)</option>
                            <option value="+291">Eritrea (+291)</option>
                            <option value="+372">Estonia (+372)</option>
                            <option value="+251">Ethiopia (+251)</option>
                            <option value="+679">Fiji (+679)</option>
                            <option value="+358">Finland (+358)</option>
                            <option value="+33">France (+33)</option>
                            <option value="+241">Gabon (+241)</option>
                            <option value="+220">Gambia (+220)</option>
                            <option value="+995">Georgia (+995)</option>
                            <option value="+49">Germany (+49)</option>
                            <option value="+233">Ghana (+233)</option>
                            <option value="+30">Greece (+30)</option>
                            <option value="+1">Grenada (+1)</option>
                            <option value="+502">Guatemala (+502)</option>
                            <option value="+224">Guinea (+224)</option>
                            <option value="+245">Guinea-Bissau (+245)</option>
                            <option value="+592">Guyana (+592)</option>
                            <option value="+509">Haiti (+509)</option>
                            <option value="+504">Honduras (+504)</option>
                            <option value="+36">Hungary (+36)</option>
                            <option value="+354">Iceland (+354)</option>
                            <option value="+91">India (+91)</option>
                            <option value="+62">Indonesia (+62)</option>
                            <option value="+98">Iran (+98)</option>
                            <option value="+964">Iraq (+964)</option>
                            <option value="+353">Ireland (+353)</option>
                            <option value="+972">Israel (+972)</option>
                            <option value="+39">Italy (+39)</option>
                            <option value="+225">Ivory Coast (+225)</option>
                            <option value="+81">Japan (+81)</option>
                            <option value="+962">Jordan (+962)</option>
                            <option value="+7">Kazakhstan (+7)</option>
                            <option value="+254">Kenya (+254)</option>
                            <option value="+686">Kiribati (+686)</option>
                            <option value="+965">Kuwait (+965)</option>
                            <option value="+996">Kyrgyzstan (+996)</option>
                            <option value="+371">Latvia (+371)</option>
                            <option value="+961">Lebanon (+961)</option>
                            <option value="+266">Lesotho (+266)</option>
                            <option value="+231">Liberia (+231)</option>
                            <option value="+18">Libya (+18)</option>
                            <option value="+423">Liechtenstein (+423)</option>
                            <option value="+370">Lithuania (+370)</option>
                            <option value="+352">Luxembourg (+352)</option>
                            <option value="+261">Madagascar (+261)</option>
                            <option value="+265">Malawi (+265)</option>
                            <option value="+60">Malaysia (+60)</option>
                            <option value="+960">Maldives (+960)</option>
                            <option value="+223">Mali (+223)</option>
                            <option value="+356">Malta (+356)</option>
                            <option value="+692">Marshall Islands (+692)</option>
                            <option value="+222">Mauritania (+222)</option>
                            <option value="+230">Mauritius (+230)</option>
                            <option value="+262">Mayotte (+262)</option>
                            <option value="+52">Mexico (+52)</option>
                            <option value="+691">Micronesia (+691)</option>
                            <option value="+373">Moldova (+373)</option>
                            <option value="+377">Monaco (+377)</option>
                            <option value="+976">Mongolia (+976)</option>
                            <option value="+382">Montenegro (+382)</option>
                            <option value="+212">Morocco (+212)</option>
                            <option value="+258">Mozambique (+258)</option>
                            <option value="+95">Myanmar (+95)</option>
                            <option value="+264">Namibia (+264)</option>
                            <option value="+674">Nauru (+674)</option>
                            <option value="+977">Nepal (+977)</option>
                            <option value="+31">Netherlands (+31)</option>
                            <option value="+64">New Zealand (+64)</option>
                            <option value="+505">Nicaragua (+505)</option>
                            <option value="+227">Niger (+227)</option>
                            <option value="+234">Nigeria (+234)</option>
                            <option value="+683">Niue (+683)</option>
                            <option value="+850">North Korea (+850)</option>
                            <option value="+1">Norway (+1)</option>
                            <option value="+968">Oman (+968)</option>
                            <option value="+92">Pakistan (+92)</option>
                            <option value="+680">Palau (+680)</option>
                            <option value="+970">Palestine (+970)</option>
                            <option value="+507">Panama (+507)</option>
                            <option value="+675">Papua New Guinea (+675)</option>
                            <option value="+595">Paraguay (+595)</option>
                            <option value="+675">Papua New Guinea (+675)</option>
                            <option value="+595">Paraguay (+595)</option>
                            <option value="+51">Peru (+51)</option>
                            <option value="+63">Philippines (+63)</option>
                            <option value="+48">Poland (+48)</option>
                            <option value="+351">Portugal (+351)</option>
                            <option value="+974">Qatar (+974)</option>
                            <option value="+40">Romania (+40)</option>
                            <option value="+7">Russia (+7)</option>
                            <option value="+250">Rwanda (+250)</option>
                            <option value="+1">Saint Kitts and Nevis (+1)</option>
                            <option value="+1">Saint Lucia (+1)</option>
                            <option value="+1">Saint Vincent and the Grenadines (+1)</option>
                            <option value="+685">Samoa (+685)</option>
                            <option value="+378">San Marino (+378)</option>
                            <option value="+239">Sao Tome and Principe (+239)</option>
                            <option value="+966">Saudi Arabia (+966)</option>
                            <option value="+221">Senegal (+221)</option>
                            <option value="+381">Serbia (+381)</option>
                            <option value="+248">Seychelles (+248)</option>
                            <option value="+232">Sierra Leone (+232)</option>
                            <option value="+65">Singapore (+65)</option>
                            <option value="+421">Slovakia (+421)</option>
                            <option value="+386">Slovenia (+386)</option>
                            <option value="+677">Solomon Islands (+677)</option>
                            <option value="+252">Somalia (+252)</option>
                            <option value="+27">South Africa (+27)</option>
                            <option value="+82">South Korea (+82)</option>
                            <option value="+211">South Sudan (+211)</option>
                            <option value="+34">Spain (+34)</option>
                            <option value="+94">Sri Lanka (+94)</option>
                            <option value="+249">Sudan (+249)</option>
                            <option value="+597">Suriname (+597)</option>
                            <option value="+46">Sweden (+46)</option>
                            <option value="+41">Switzerland (+41)</option>
                            <option value="+886">Taiwan (+886)</option>
                            <option value="+992">Tajikistan (+992)</option>
                            <option value="+255">Tanzania (+255)</option>
                            <option value="+66">Thailand (+66)</option>
                            <option value="+670">Timor-Leste (+670)</option>
                            <option value="+228">Togo (+228)</option>
                            <option value="+676">Tonga (+676)</option>
                            <option value="+1">Trinidad and Tobago (+1)</option>
                            <option value="+216">Tunisia (+216)</option>
                            <option value="+90">Turkey (+90)</option>
                            <option value="+993">Turkmenistan (+993)</option>
                            <option value="+688">Tuvalu (+688)</option>
                            <option value="+256">Uganda (+256)</option>
                            <option value="+380">Ukraine (+380)</option>
                            <option value="+971">United Arab Emirates (+971)</option>
                            <option value="+44">United Kingdom (+44)</option>
                            <option value="+1">United States (+1)</option>
                            <option value="+598">Uruguay (+598)</option>
                            <option value="+998">Uzbekistan (+998)</option>
                            <option value="+678">Vanuatu (+678)</option>
                            <option value="+39">Vatican City (+39)</option>
                            <option value="+58">Venezuela (+58)</option>
                            <option value="+84">Vietnam (+84)</option>
                            <option value="+967">Yemen (+967)</option>
                            <option value="+260">Zambia (+260)</option>
                            <option value="+263">Zimbabwe (+263)</option>
    
                        </datalist>
                            
                        <input type="tel" id="cellphone" v-model="data.cellphone" placeholder="XXXX XXXX" required>
                        <span class="info-icon" @mouseover="showPopup('Ingrese su n&uacute;mero de tel&eacute;fono para recordatorios.')" @mouseleave="hidePopup">&#9432;</span>
                    </div>
                </div>

                
                <div class="form-group">
                    <label for="level">Nivel de Ingl&eacute;s Actual (Aproximado):</label>
                    <select id="level" v-model="data.level" required>
                        <option value="">Seleccione</option>
                        <option value="beginner">Principiante (A1)</option>
                        <option value="intermediate">Básico-Intermedio (A2-B1)</option>
                        <option value="high intermediate">Intermedio (B2)</option>
                        <option value="advanced">Avanzado (B2-C1)</option>
                    </select>
                    <span class="info-icon" @mouseover="showPopup('Seleccione su nivel de ingl&eacute;s actual.')" @mouseleave="hidePopup">&#9432;</span>
                </div>


                <div class="form-group">
                    <label for="comments">Comentarios:</label>
                    <textarea id="comments" v-model="data.comments" rows="3"></textarea>
                    <span class="info-icon" @mouseover="showPopup('Ingrese comentarios adicionales como objetivos y experiencia previa.')" @mouseleave="hidePopup">&#9432;</span>
                </div>
                
                <button @click.stop.prevent="schedule_demo()" type="submit">Agendar Clase Gratis</button>
            </form>
            <div v-if="popupVisible" class="popup">{{ popupText }}</div>
        </div>
    </div>
</template>

<script setup>
import { ref,reactive,onMounted } from 'vue';
import axios from 'axios';




const popupVisible = ref(false);
const popupText = ref('');

let data=reactive({
    first_name: "",
    last_name: "",
    date: "",
    time: "",
    datetime:true,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    email: "",
    country_code: "",
    cellphone: "",
    level: "",
    comments: "",
    logo: require('@/assets/logo.png'),
    origin:"null"

})



import {useRoute,useRouter} from 'vue-router'

let route=useRoute()


onMounted(()=>{
    if (route.query.origin){
        data.origin=route.query.origin
    }

})




async function schedule_demo() {

    let nullKeys = [];
    for (let [key, value] of Object.entries(data)) {
        console.log(`Key: ${key}, Value: ${value}`);
        if (value == null || value == "") {
            nullKeys.push(key);
        }
    }

    if (nullKeys.length > 0) {
        alert(`Please fill out the following fields: ${nullKeys.join(', ')}`);
        return;
    }

    data.datetime = new Date(`${data.date}T${data.time}:00`).toISOString();
    

    let response=await axios.post('/leads/schedule_demo/', data);
    console.log(response.status)
    if (response.status==200){
        alert("Your request has been sent, we will contact you as soon as possible.")
        window.location.href="/";
        // window.location.href="https://wa.me/525515902969?text=Hola,%20busco%20informacion%20sobre%20las%20clases%20de%20ingl%C3%A9s"        
        window.location.href=`https://wa.me/525515902969?text=Hola,%20me%20llamo%20${data.first_name}%20y%20busco%20informacion%20sobre%20las%20clases%20de%20ingl%C3%A9s%20al%20nive%20de%20${data.level}`
    }
    else{
        alert("There was an error submitting your request. Please go to home page and use the contact buttons there.")
    }
}



function showPopup(text) {
    popupText.value = text;
    popupVisible.value = true;
}

function hidePopup() {
    popupVisible.value = false;
}
</script>





<style scoped>
body, html {
    height: 100%;
    margin: 0;
    font-family: var(--ubuntu), sans-serif;
}
.schedule-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    width: 100vw;
    background: linear-gradient(135deg, var(--lightblue), var(--lightgreen));
    overflow: hidden;
}
.schedule {
    /* background: rgba(255, 255, 255, 0.9); */
    background: rgba(234, 239, 242, 0.6); 
    backdrop-filter: blur(4px);
    padding: 30px;
    border-radius: 15px;
    box-shadow: var(--shadow);
    text-align: center;
    color: var(--black);
    width: 450px;
    position: relative;
    border: var(--inactive-border);
}
.schedule h2 {
    margin-bottom: 20px;
    color: var(--blue);
    text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.3);
}
.schedule-form {
    display: flex;
    flex-direction: column;
    gap: 12px;
}
.form-group {
    position: relative;
    display: flex;
    align-items: center;
    gap: 2px;
    flex-direction: column;
    align-items: flex-start;
    
    padding: 6px;
    border-radius: 15px;
    background: rgba(255, 255, 255, 0.6);
    backdrop-filter: blur(2px);
    
}
label {

    color: var(--blue);
    font-weight: bold;
    text-align: left;
}
input {

    padding: 10px;
    border: none;
    border-radius: 15px;
    outline: none;
    font-size: 14px;
    width: 100%;
    background: rgba(132, 189, 186, 0.425);
    color: var(--black);
    border: var(--inactive-border);
}
input::placeholder {
    color: var(--darkinactive);
}


.cellphone_info{
    display:flex;
    flex-direction:row;
    align-items:center;
    justify-content:center;
}

.cellphone{
    width:100px;
}

button {
    background: var(--blue);
    color: var(--white);
    border: none;
    padding: 12px;
    border-radius: 10px;
    font-size: 16px;
    cursor: pointer;
    font-weight: bold;
    transition: var(--transition);
    width: 100%;
    border: var(--inactive-border);
}
button:hover {
    background: var(--lightblue);
}
.info-icon {
    color: var(--blue);
    cursor: pointer;
    font-size: 14px;
    font-weight: bold;
    position: absolute;
    right: 10px;
}
.popup {
    position: absolute;
    background: var(--darkinactive);
    color: var(--white);
    padding: 10px;
    border-radius: 5px;
    top:50%;
    right: 50%;
    transform: translateX(-50%,-50%);
    font-size: 14px;
    white-space: nowrap;
}

#comments{
    width:100%;
}


#logo{
    position:absolute;
    top:50%;
    left:50%;
    transform:translate(-50%,-50%);
    opacity:0.7;
}



</style>
